const isOffline = () => process.env.REACT_APP_OFFLINE === "true";

export default isOffline;